import { getRepository } from './repository';

const resource = "/template_format";

export default {
    get(headers, limit) {
        return getRepository().get(`${resource}/list?limit=${limit}`, {headers : headers});
    },
    createFormat(payload, headers) {
        return getRepository().post(`${resource}/add`, payload, {headers : headers});
    },
    updateFormat(payload, headers) {
        return getRepository().post(`${resource}/update`, payload, {headers : headers});
    },
    deleteFormat(formatId, headers) {
        return getRepository().post(`${resource}/remove`, {"id" : formatId}, {headers : headers})
    }
};